var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatattach(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03107 8.10678L9.18563 3.96214L9.79047 3.3573L10.2466 2.90119C10.3061 2.8417 10.3656 2.78221 10.435 2.7128C10.9803 2.16745 11.5554 1.64193 12.3486 1.55269C13.7566 1.38413 15.1547 2.77229 14.9861 4.19019C14.887 4.98343 14.3714 5.55852 13.826 6.10387C13.7665 6.16336 13.7071 6.22285 13.6376 6.29226L13.1815 6.74837L12.5767 7.35321C11.952 7.97788 10.0185 9.86181 9.39385 10.4865C8.08501 11.7953 6.64728 13.1042 4.67411 12.9951C3.59333 12.9356 2.5423 12.539 1.8383 11.6862C0.995492 10.6749 0.817015 9.47511 1.17397 8.2456C1.61025 6.77812 2.82984 5.64776 3.90071 4.63639C5.20954 3.37713 8.02552 0.650391 8.02552 0.650391",
    stroke: "#848E9D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatattach);
export default __webpack_public_path__ + "static/media/chatattach.4fa8d2baf25ee92c4c63f52f1fb71d87.svg";
export { ForwardRef as ReactComponent };